import React from 'react';
import TextWinds from '../TextWinds';
import ErrorInput from '../ErrorInput';

/** 라벨 + 입력 + 에러 메시지를 한 벌로 묶은 폼 항목 */
export const Field = ({
  label,
  hint,
  error,
  success,
  help,
  className,
  children,
}: {
  label: string;
  hint?: string;
  error?: string;
  /** 검사를 통과했을 때 보여줄 안내. 에러가 있으면 에러를 우선한다. */
  success?: string;
  /** 입력 아래에 늘 띄워두는 안내. 에러·성공 메시지가 있으면 그 자리를 내준다. */
  help?: string;
  className?: string;
  children: React.ReactNode;
}) => (
  <div className={`flex flex-col ${className ?? ''}`}>
    <div className="mb-2 flex items-center gap-x-1.5">
      <TextWinds type="content_body3" color="gray7">
        {label}
      </TextWinds>
      {hint && (
        <span className="select-none rounded bg-gray2 px-1.5 py-0.5 text-xs text-gray6">
          {hint}
        </span>
      )}
    </div>
    {children}
    {/* 메시지가 나타나도 행 높이가 변하지 않도록 caption1 한 줄(20px) 높이를 항상 비워둔다. */}
    <div className="mt-1 min-h-5">
      {error ? (
        <ErrorInput text={error} />
      ) : success ? (
        <TextWinds type="caption1" color="purple5">
          {success}
        </TextWinds>
      ) : (
        help && (
          <TextWinds type="caption1" color="gray6">
            {help}
          </TextWinds>
        )
      )}
    </div>
  </div>
);

/** 수정할 수 없는 항목(이름, 아이디) */
export const ReadOnlyField = ({
  label,
  value,
  hint,
}: {
  label: string;
  value?: string;
  hint?: string;
}) => (
  <Field label={label} hint={hint}>
    <div className="flex h-[50px] cursor-not-allowed items-center rounded border border-gray3 bg-gray-100 px-3">
      <TextWinds type="content_body2" color="gray8">
        {value || '-'}
      </TextWinds>
    </div>
  </Field>
);
